import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Connexion from './components/connexion/connexion';
import Inscription from './components/connexion/inscription';
import Liste_utilisateur from './components/administration/utilisateur/liste_utilisateur';
import Admin from './components/administration/admin';
import ListeGroupe from './components/administration/groupe/liste_groupe';
import ConfigurerGroupe from './components/administration/groupe/configurer_groupe';
import Dashboard from './components/administration/dashboard/dashboard';
import ProfilAdministrateur from './components/administration/dashboard/mon_profil';
import Journalisation from './components/administration/journalisation';
import Liste_motssensibles from './components/administration/mots_sensibles/liste_motssensibles';
import ListeCategorie from './components/administration/mots_sensibles/liste_categories';
import ListeCategorieEvenement from './components/administration/evenement/categorie_evenement';
import ListeEvenement from './components/administration/evenement/evenement';
import ConfigurerEvenement from './components/administration/evenement/configurer_evenement';
import ListeEvenementSignales from './components/administration/groupe/event_signal';
import Signalements from './components/administration/groupe/signalement';
import DemandesReexamen from './components/administration/groupe/liste_demande_reexamen';


function App() {
  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
    <Router>
      <Routes>
        <Route path="/" element={<Connexion/>} />
        <Route path="/Inscription" element={<Inscription/>} />
        <Route path="/Dashboard" element={<Dashboard/>} />
        <Route path="/Admin" element={<Admin/>} />
        <Route path="/Liste-utilisateur" element={<Liste_utilisateur/>} />
        <Route path="/Liste-groupe" element={<ListeGroupe/>} />
        <Route path="/Configurer-groupe" element={<ConfigurerGroupe/>} />
        <Route path="/Dashboard" element={<Dashboard/>} />
        <Route path="/Mon-profil" element={<ProfilAdministrateur/>} />
        <Route path="/Liste-evenements-signales" element={<ListeEvenementSignales />} />
        <Route path="/Liste-signalements" element={<Signalements />} />
        <Route path="/Liste-demande-reexamen" element={<DemandesReexamen />} />
        <Route path="/Liste-journalisation" element={<Journalisation />} />
        <Route path="/Liste-mots-sensibles" element={<Liste_motssensibles />} />
        <Route path="/Liste-categorie-mots_sensibles" element={<ListeCategorie />} />
        <Route path="/Liste-categorie-evenement" element={<ListeCategorieEvenement />} />
        <Route path="/Liste-evenement" element={<ListeEvenement />} />
        <Route path="/Configurer-evenement" element={<ConfigurerEvenement />} />
      </Routes>
    </Router>
  );
}

export default App;
